/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateEventDto } from '../models/CreateEventDto';
import type { UpdateEventDto } from '../models/UpdateEventDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EventsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create a new event
     * @param requestBody
     * @returns any Event created successfully
     * @throws ApiError
     */
    public create(
        requestBody: CreateEventDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/events',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get events visible to the authenticated user
     * @returns any Events retrieved successfully
     * @throws ApiError
     */
    public findAll(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events',
        });
    }

    /**
     * Get all events (med staff)
     * @returns any Events retrieved successfully
     * @throws ApiError
     */
    public findAllForDoctor(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events/doctor',
        });
    }

    /**
     * Get event by ID (med staff)
     * @param id
     * @returns any Event retrieved successfully
     * @throws ApiError
     */
    public findByIdForDoctor(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events/doctor/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Event not found`,
            },
        });
    }

    /**
     * Get event by ID
     * @param id
     * @returns any Event retrieved successfully
     * @throws ApiError
     */
    public findById(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Event not found`,
            },
        });
    }

    /**
     * Update event by ID
     * @param id
     * @param requestBody
     * @returns any Event updated successfully
     * @throws ApiError
     */
    public update(
        id: string,
        requestBody: UpdateEventDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/events/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Event not found`,
            },
        });
    }

    /**
     * Delete event by ID
     * @param id
     * @returns any Event deleted successfully
     * @throws ApiError
     */
    public delete(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/events/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Event not found`,
            },
        });
    }

}
